import { SIZE } from 'common/sizes';
import styled from 'styled-components';

export const Root = styled.div`
  display: inline-block;
`;

export const Col = styled.div`
  width: 432px;
  display:inline-block;  
  position:relative;
  &:after{
    content: " ";
    position: absolute;
    border-left: 1px rgba(32, 64, 120, 0.2) solid;
    top: 15%;
    right: 0;
    height: 60%;
    margin-top: auto;
    margin-bottom: auto;
  }
`;

export const InputSearch = styled.input`
  font-family: Rubik;
  height: 48px;
  font-size: 16px;
  text-align: left;
  color: rgba(141, 141, 141, 0.5);
  padding: 0px 16px;
  border: unset;
  width: 80%;
  &::placeholder {
    color: rgba(141, 141, 141, 0.5);
  }
  &:hover, &:focus {
    color: #8d8d8d;
  }
  &:focus {
        outline: none;
  }
`

export const Icon = styled.div`
  position: absolute;
  top: 15px;
  right: 5px;
  cursor: pointer;
  margin: 0 ${SIZE.TWO}px;
`;

export const SearchList = styled.div`
  width: 100%;
  height: auto;
  display: none;
  position: absolute;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  z-index: 1;
  margin-top: 7px; 
`;

export const OptionsContaine = styled.div`
  height: auto;
  max-height: 220px;
  overflox-x: hidden;
  overflow-y: auto;
`;

export const Option = styled.div`
  width: auto;
  height: 19px;
  flex-grow: 0;
  padding: 8px 16px;
  background-color: #ffffff;
  font-size: 16px;
  font-weight: normal;
  color: #272727;
  cursor:pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:hover{
    background-color: rgba(18, 36, 66, 0.05);
  }
`;

export const Tag = styled.span`
  display: inline-block;
  color: #8f9fbb;
  text-transform: capitalize;
  margin-left: 4px;
`;